import { Controller } from '@hotwired/stimulus'

import '../../entrypoints/modules/semantic-ui-dropdown'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import { trans, SETUP_TIMINGS, LOG_INTEGRATION_REQUIRED, LOG_TICKETS_SOLD_REQUIRED, LOG_START } from '../../translator'
import createFieldRule from '../../modules/validation/validation'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'

global.moment = require('moment')

export default class extends Controller {
  static values = {
    entityType: String,
    logStartsAt: { type: String, default: null },
    logEndsAt: { type: String, default: null },
    numberOfDays: { type: Number, default: 1 }
  }

  static targets = [
    'container'
  ]

  connect () {
    this.setupLogIntegrations(this.element.querySelectorAll('.logIntegration'))

    this.addToDropdownsHandler = this.addToDropdowns.bind(this)
    this.removeFromDropdownsHandler = this.removeFromDropdowns.bind(this)
    this.updateLogIntegrationsHandler = () => {
      this.updateLogIntegrations(this.element.querySelectorAll('.logIntegration'))
    }
    this.updateNumberOfDaysHandler = (event) => {
      this.logStartsAtValue = event.detail.startsAt ? event.detail.startsAt : null
      this.logEndsAtValue = event.detail.endsAt ? event.detail.endsAt : null
      this.updateNumberOfDays(event.detail.numberOfDays)
    }

    document.addEventListener('timings:timing:added', this.addToDropdownsHandler)
    document.addEventListener('timings:timing:removed', this.removeFromDropdownsHandler)
    document.addEventListener('timings:isApplyToAllDays:updated', this.updateLogIntegrationsHandler)
    document.addEventListener('timings:date:updated', this.updateNumberOfDaysHandler)
  }

  disconnect () {
    document.removeEventListener('timings:timing:added', this.addToDropdownsHandler)
    document.removeEventListener('timings:timing:removed', this.removeFromDropdownsHandler)
    document.removeEventListener('timings:isApplyToAllDays:updated', this.updateLogIntegrationsHandler)
    document.removeEventListener('timings:date:updated', this.updateNumberOfDaysHandler)
  }

  setupLogIntegrations (logIntegrations) {
    logIntegrations.forEach((logIntegration) => {
      const integrationDropdown = logIntegration.querySelector('.integration')
      const newFormRule = {
        [integrationDropdown.id]: createFieldRule(integrationDropdown.id, 'empty', trans(LOG_INTEGRATION_REQUIRED, {}, 'logs'))
      }

      const form = $('#form')
      const currentFormRules = form.form('setting', 'fields')
      form.form('destroy')
      form.form({ fields: { ...currentFormRules, ...newFormRule }, inline: true })

      $(integrationDropdown).dropdown({
        forceSelection: false,
        onChange: (value, text, choice) => {
          if (integrationDropdown.dataset.readonly === 'true') {
            return
          }

          if (this.entityTypeValue === 'log') {
            logIntegration.querySelectorAll('.fortressEventSelector').forEach((fortressEventSelector) => {
              fortressEventSelector.classList.remove('error')
            })

            logIntegration.querySelectorAll('.ticketsSoldContainer').forEach((ticketsSoldContainer) => {
              ticketsSoldContainer.classList.remove('error')
            })

            logIntegration.querySelectorAll('.ticketsSold').forEach((ticketsSold) => {
              ticketsSold.value = null
            })

            const option = integrationDropdown.querySelector('option[value="' + value + '"]')
            if (option && option.dataset.type === 'Evolv') {
              this.hideTicketsSold(logIntegration)
            } else {
              this.showTicketsSold(logIntegration)
            }

            const type = option ? option.dataset.type : null
            this.updateLogIntegrationByType(logIntegration, type)
          }
        }
      })

      if (integrationDropdown.dataset.readonly === 'true') {
        integrationDropdown.closest('.ui.dropdown').classList.add('disabled')
      }

      this.setupIntegrationPollSchedules(logIntegration.querySelectorAll('.integrationPollSchedule'))
      this.updateIntegrationPollSchedules(logIntegration.querySelectorAll('.integrationPollSchedule'))
    })
  }

  updateLogIntegrationByType (logIntegration, type) {
    if (type === 'Evolv') {
      this.hideTicketsSold(logIntegration)
      logIntegration.querySelectorAll('.fortressEventSelector').forEach((fortressEventSelector) => {
        fortressEventSelector.classList.add('d-none')
      })
    } else if (type === 'Fortress') {
      this.showTicketsSold(logIntegration)
      logIntegration.querySelectorAll('.fortressEventSelector').forEach((fortressEventSelector) => {
        fortressEventSelector.classList.remove('d-none')
      })

      if (this.logStartsAtValue !== null && this.logEndsAtValue !== null) {
        logIntegration.querySelectorAll('.integrationPollSchedule').forEach((integrationPollSchedule) => {
          this.getFortressEvents(logIntegration, integrationPollSchedule)
        })
      }
    } else {
      this.showTicketsSold(logIntegration)
      logIntegration.querySelectorAll('.fortressEventSelector').forEach((fortressEventSelector) => {
        fortressEventSelector.classList.add('d-none')
      })
    }
  }

  hideTicketsSold (logIntegration) {
    logIntegration.querySelectorAll('.pollTimingsContainer').forEach((pollTimingsContainer) => {
      pollTimingsContainer.classList.remove('col-9')
      pollTimingsContainer.classList.add('col-11')
    })
    logIntegration.querySelector('.pollTimingsHeaderContainer').classList.remove('col-9')
    logIntegration.querySelector('.pollTimingsHeaderContainer').classList.add('col-11')
    logIntegration.querySelectorAll('.ticketsSoldContainer').forEach((ticketsSoldContainer) => {
      ticketsSoldContainer.classList.add('d-none')
      ticketsSoldContainer.querySelector('.ticketsSold').disabled = true
    })
    logIntegration.querySelector('.ticketsSoldHeaderContainer').classList.add('d-none')
    logIntegration.querySelector('.ticketsSoldHeaderContainer').classList.remove('error')
  }

  showTicketsSold (logIntegration) {
    logIntegration.querySelectorAll('.pollTimingsContainer').forEach((pollTimingsContainer) => {
      pollTimingsContainer.classList.remove('col-11')
      pollTimingsContainer.classList.add('col-9')
    })
    logIntegration.querySelector('.pollTimingsHeaderContainer').classList.add('col-9')
    logIntegration.querySelector('.pollTimingsHeaderContainer').classList.remove('col-11')
    logIntegration.querySelectorAll('.ticketsSoldContainer').forEach((ticketsSoldContainer) => {
      ticketsSoldContainer.classList.remove('d-none')
      ticketsSoldContainer.querySelector('.ticketsSold').removeAttribute('disabled')
    })
    logIntegration.querySelector('.ticketsSoldHeaderContainer').classList.remove('d-none')
  }

  setupIntegrationPollSchedules (integrationPollSchedules) {
    integrationPollSchedules.forEach((integrationPollSchedule) => {
      integrationPollSchedule.querySelectorAll('.startTiming, .endTiming').forEach((timing) => {
        $(timing).dropdown({
          clearable: true,
          forceSelection: false,
          message: {
            noResults: trans(SETUP_TIMINGS, {}, 'logs')
          },
          onChange: function () {
            if (timing.dataset.readonly === 'true') {
              return false
            }
          }
        })

        if (timing.dataset.readonly === 'true') {
          timing.closest('.ui.dropdown').classList.add('disabled')
        }
      })
    })
  }

  updateLogIntegrations (logIntegrations) {
    logIntegrations.forEach((logIntegration) => {
      this.updateIntegrationPollSchedules(logIntegration.querySelectorAll('.integrationPollSchedule'))
    })
  }

  updateIntegrationPollSchedules (integrationPollSchedules) {
    integrationPollSchedules.forEach((integrationPollSchedule) => {
      if (this.entityTypeValue === 'log') {
        this.updateDate(integrationPollSchedule)
        this.updateFormRules(integrationPollSchedule)
      }
      this.updateTimings(integrationPollSchedule)
    })
  }

  updateDate (integrationPollSchedule) {
    const pollDate = integrationPollSchedule.querySelector('.pollDate')
    const numberOfDays = parseInt(pollDate.querySelector('input').value) ?? 0
    const logStartDate = moment(document.querySelector('#log-start-date').querySelector('input').value, accountDateFormat.toUpperCase())
    pollDate.querySelector('span').innerHTML = logStartDate.isValid()
      ? logStartDate.add(numberOfDays, 'days').format(accountDateFormat.toUpperCase())
      : trans(LOG_START, {}, 'logs')
  }

  updateTimings (integrationPollSchedule) {
    integrationPollSchedule.querySelectorAll('.startTiming, .endTiming').forEach((timing) => {
      Array.from(timing.querySelector('select').options).forEach(option => {
        if (option.value !== '' && !option.selected) {
          option.remove()
        }
      })

      if (this.numberOfDaysValue > 1 && document.querySelector('#applyTimingsToAllDaysInput').checked) {
        document.querySelectorAll('.timing-group[data-day="0"] .log-event-select').forEach((select) => {
          if ($(select).dropdown('get value') !== '' && $(timing).dropdown('get value') !== $(select).dropdown('get value')) {
            timing.querySelector('select').append(new Option($(select).dropdown('get text'), $(select).dropdown('get value')))
          }
        })
      } else {
        const index = timing.closest('.integrationPollSchedule').dataset.index ?? 0
        document.querySelectorAll('.timing-group[data-day="'+index+'"] .log-event-select').forEach((select) => {
          if ($(select).dropdown('get value') !== '' && $(timing).dropdown('get value') !== $(select).dropdown('get value')) {
            timing.querySelector('select').append(new Option($(select).dropdown('get text'), $(select).dropdown('get value')))
          }
        })
      }

      const selectedValue = $(timing).dropdown('get value')
      const optionExists = Array.from(timing.querySelector('select').options).some(option => option.value === selectedValue)
      if (!optionExists) {
        $(timing).dropdown('clear')
      }

      $(timing).dropdown('refresh')
    })
  }

  updateFormRules (integrationPollSchedule) {
    const ticketsSold = integrationPollSchedule.querySelector('.ticketsSold')
    const newFormRule = {
      [ticketsSold.id]: createFieldRule(ticketsSold.id, 'regExp[/^[1-9]\\d*$/]', trans(LOG_TICKETS_SOLD_REQUIRED, {}, 'logs'))
    }

    const form = $('#form')
    const currentFormRules = form.form('setting', 'fields')
    form.form('destroy')
    form.form({ fields: { ...currentFormRules, ...newFormRule }, inline: true })
  }

  addToDropdowns (event) {
    if (event.detail.isApplyToAllDays || this.entityTypeValue === 'logTemplate') {
      this.element.querySelectorAll('.startTiming, .endTiming').forEach((timing) => {
        timing.querySelector('select').append(new Option(event.detail.timingName, event.detail.timingId))
        $(timing).dropdown('refresh')
      })
    } else {
      this.element.querySelectorAll('.day').forEach((pollDay) => {
        if (pollDay.value === event.detail.day) {
          pollDay.closest('.integrationPollSchedule').querySelectorAll('.startTiming, .endTiming').forEach((timing) => {
            timing.querySelector('select').append(new Option(event.detail.timingName, event.detail.timingId))
            $(timing).dropdown('refresh')
          })
        }
      })
    }
  }

  removeFromDropdowns (event) {
    if (event.detail.isApplyToAllDays || this.entityTypeValue === 'logTemplate') {
      this.element.querySelectorAll('.startTiming, .endTiming').forEach((timing) => {
        if ($(timing).dropdown('get value') === event.detail.timingId) {
          $(timing).dropdown('clear')
        }

        timing.querySelector('select').querySelector(`option[value="${event.detail.timingId}"]`).remove()
        $(timing).dropdown('refresh')
      })
    } else {
      this.element.querySelectorAll('.day').forEach((pollDay) => {
        if (pollDay.value === event.detail.day) {
          pollDay.closest('.integrationPollSchedule').querySelectorAll('.startTiming, .endTiming').forEach((timing) => {
            if ($(timing).dropdown('get value') === event.detail.timingId) {
              $(timing).dropdown('clear')
            }

            timing.querySelector('select').querySelector(`option[value="${event.detail.timingId}"]`).remove()
            $(timing).dropdown('refresh')
          })
        }
      })
    }
  }

  addLogIntegration () {
    const prototype = this.containerTarget.dataset.prototype
    const numberOfLogIntegrations = this.containerTarget.children.length
    const newForm = prototype.replace(/__name__/g, numberOfLogIntegrations)

    const newElement = document.createElement('div')
    newElement.classList.add('logIntegration')
    newElement.dataset.index = numberOfLogIntegrations
    newElement.innerHTML = newForm

    if (numberOfLogIntegrations > 0) {
      const hr = document.createElement('hr')
      newElement.prepend(hr)
    }

    for (let day = 0; day < this.numberOfDaysValue; day++) {
      this.addIntegrationPollSchedule(newElement, numberOfLogIntegrations, day)
    }

    this.containerTarget.appendChild(newElement)
    this.setupLogIntegrations([newElement])
  }

  addIntegrationPollSchedule (logIntegration, numberOfLogIntegrations, day) {
    const schedulePrototype = this.containerTarget.dataset.schedulePrototype
    const newScheduleForm = schedulePrototype
      .replace(/logIntegrations___name___/g, `logIntegrations_${numberOfLogIntegrations}_`)
      .replace(/logIntegrations]\[__name__/g, `logIntegrations][${numberOfLogIntegrations}`)
      .replace(/integrationPollSchedules___name___/g, `integrationPollSchedules_${day}_`)
      .replace(/integrationPollSchedules]\[__name__/g, `integrationPollSchedules][${day}`)
      .replace('data-index=""', `data-index="${day}"`)
      .replace('value="0"', `value="${day}"`)

    logIntegration.querySelector('.integrationPollSchedules').insertAdjacentHTML('beforeend', newScheduleForm)
    if (this.entityTypeValue === 'log') {
      const integrationPollSchedules = logIntegration.querySelectorAll('.integrationPollSchedule')
      const lastIntegrationPollSchedule = integrationPollSchedules[integrationPollSchedules.length - 1]
      lastIntegrationPollSchedule.querySelector('.day').value = day
    }
    this.setupIntegrationPollSchedules([logIntegration])
  }

  updateNumberOfDays (numberOfDays) {
    this.numberOfDaysValue = numberOfDays
    this.element.querySelectorAll('.logIntegration').forEach((logIntegration, index) => {
      const integrationPollSchedules = logIntegration.querySelectorAll('.integrationPollSchedule')
      if (integrationPollSchedules.length < numberOfDays) {
        for (let day = integrationPollSchedules.length; day < numberOfDays; day++) {
          this.addIntegrationPollSchedule(logIntegration, index, day)
        }
      } else if (integrationPollSchedules.length > numberOfDays) {
        integrationPollSchedules.forEach((integrationPollSchedule, index) => {
          if (index >= numberOfDays) {
            integrationPollSchedule.remove()
          }
        })
      }

      this.updateIntegrationPollSchedules(logIntegration.querySelectorAll('.integrationPollSchedule'))

      const selectedOption = logIntegration.querySelector('.integration option[value="' + $(logIntegration.querySelector('.integration')).dropdown('get value') + '"]')
      const type = selectedOption ? selectedOption.dataset.type : null
      this.updateLogIntegrationByType(logIntegration, type)
    })

    this.element.querySelectorAll('.findFortressEventButton').forEach((findFortressEventButton) => {
      findFortressEventButton.classList.remove('disabled')
    })
  }

  removeLogIntegration (event) {
    const element = event.target.closest('.logIntegration')

    const form = $('#form')
    const currentFormRules = form.form('setting', 'fields')

    // Remove rules for fields within the element being removed
    element.querySelectorAll('input, select, textarea').forEach((field) => {
      if (currentFormRules[field.id]) {
        delete currentFormRules[field.id]
      }
    })

    form.form('destroy')
    form.form({ fields: currentFormRules, inline: true })

    element.remove()
  }

  selectFortressEvent (event) {
    Array.from(event.currentTarget.closest('.fortressEvents').children).forEach((fortressEvent) => {
      fortressEvent.classList.add('opacity-3')
      fortressEvent.querySelector('.select').classList.remove('d-none')
      fortressEvent.querySelector('.selectConfirmation').classList.add('d-none')
    })
    event.currentTarget.closest('.fortressEvent').classList.remove('opacity-3')

    event.currentTarget.classList.add('d-none')
    event.currentTarget.parentElement.querySelector('.selectConfirmation').classList.remove('d-none')
  }

  cancelSelectFortressEvent (event) {
    Array.from(event.currentTarget.closest('.fortressEvents').children).forEach((fortressEvent) => {
      fortressEvent.classList.remove('opacity-3')
      fortressEvent.querySelector('.select').classList.remove('d-none')
      fortressEvent.querySelector('.selectConfirmation').classList.add('d-none')
    })
  }

  confirmSelectFortressEvent (event) {
    event.currentTarget.closest('.fortressEventSelector').classList.remove('error')
    event.currentTarget.closest('.fortressEventSelector').querySelector('.fortressError').classList.add('d-none')

    const selectedEvent = event.currentTarget.closest('.fortressEvent')
    Array.from(event.currentTarget.closest('.fortressEvents').children).forEach((fortressEvent) => {
      if (fortressEvent !== selectedEvent) {
        fortressEvent.remove()
      } else {
        fortressEvent.firstElementChild.classList.remove('col-11')
        fortressEvent.firstElementChild.classList.add('col-12')
      }
    })

    event.currentTarget.parentElement.classList.add('d-none')
  }

  getFortressEvents (logIntegration, integrationPollSchedule) {
    integrationPollSchedule.querySelector('.fortressEventSelector').classList.remove('error')
    integrationPollSchedule.querySelector('.fortressError').classList.add('d-none')

    const integrationId = $(logIntegration.querySelector('.integration')).dropdown('get value')
    integrationPollSchedule.querySelector('.fortressEvents').classList.add('d-none')
    integrationPollSchedule.querySelector('.fortressLoading').classList.remove('d-none')
    fetchWithHandlingLoginRedirect('/integrations/' + integrationId + '/fortress-events?' +
      'startDate=' + this.logStartsAtValue +
      '&endDate=' + this.logEndsAtValue +
      '&logIntegrationFormIndex=' + logIntegration.dataset.index +
      '&integrationPollScheduleFormIndex=' + integrationPollSchedule.dataset.index
    )
      .then(response => {
        if (response.status === 200) {
          return response.text()
        }
        return Promise.reject(response)
      })
      .then(html => {
        const replacedHtml = html
          .replace(/logIntegrations]\[__name__/g, `logIntegrations][${logIntegration.dataset.index}`)
          .replace(/integrationPollSchedules]\[__name__/g, `integrationPollSchedules][${integrationPollSchedule.dataset.index}`)

        integrationPollSchedule.querySelector('.fortressLoading').classList.add('d-none')
        integrationPollSchedule.querySelector('.fortressEvents').innerHTML = replacedHtml
        integrationPollSchedule.querySelector('.fortressEvents').classList.remove('d-none')
        integrationPollSchedule.querySelector('.fortressError').classList.add('d-none')
      })
      .catch(_error => {
        integrationPollSchedule.querySelector('.fortressLoading').classList.add('d-none')
        integrationPollSchedule.querySelector('.fortressError').classList.remove('d-none')
      })
  }

  refreshFortressEvent (event) {
    if (this.logStartsAtValue !== null && this.logEndsAtValue !== null) {
      const logIntegration = event.currentTarget.closest('.logIntegration')
      const integrationPollSchedule = event.currentTarget.closest('.integrationPollSchedule')
      this.getFortressEvents(logIntegration, integrationPollSchedule)
    }
  }
}
